import * as React from "react";
function SvgFilter(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#filter_svg__clip0_1341_6776)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.293 7.25h-18v-2.5h18v2.5zm-2 6h-14v-2.5h14v2.5zm-11 6h8v-2.5h-8v2.5z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="filter_svg__clip0_1341_6776">
                    <path
                        fill="#fff"
                        transform="translate(.293)"
                        d="M0 0h24v24H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFilter);
export default ForwardRef;
